module.exports = __webpack_public_path__ + "img/asian-salad-1.2f7a0952.jpg";